import * as React from 'react';
import Menu from '@material-ui/core/Menu';
import MenuItem from '@material-ui/core/MenuItem';
import { createTheme, ThemeProvider, ListItemText } from '@material-ui/core';
import { fontFamilies } from '../../theme/text';

interface DropdownMenuItem {
  text: string;
  eventHandler: () => any;
  icon?: any;
}

interface Props {
  anchorEl: any;
  menuItems: DropdownMenuItem[];
  setAnchorEl: (el: any) => void;
}

const materialTheme = createTheme({
  overrides: {
    MuiMenuItem: {
      root: {
        color: '#006DA8',
        paddingTop: '2px',
        paddingBottom: '2px',
        '&$selected': {
          backgroundColor: '#eaf3f8 !important',
          color: 'black'
        }
      }
    },
    MuiListItemText: {
      primary: {
        fontFamily: fontFamilies.heading,
        fontSize: '11px !important',
        color: '#006DA8',
        textTransform: 'uppercase',
        marginLeft: '4px'
      }
    },
    MuiSvgIcon: {
      root: {
        height: 18,
        width: 18
      }
    }
  }
});

const DropdownMenu = ({ menuItems, anchorEl, setAnchorEl }: Props) => {
  const handleClose = () => {
    setAnchorEl(null);
  };

  return (
    <div>
      <ThemeProvider theme={materialTheme}>
        <Menu id="simple-menu" anchorEl={anchorEl} open={Boolean(anchorEl)} onClose={handleClose}>
          {menuItems.map(item => (
            <MenuItem
              key={item.text}
              onClick={() => {
                item.eventHandler();
                handleClose();
              }}
            >
              {item.icon && <item.icon />}
              <ListItemText>{item.text}</ListItemText>
            </MenuItem>
          ))}
        </Menu>
      </ThemeProvider>
    </div>
  );
};

export default DropdownMenu;
